import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, ContentChild } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { TopbarComponent } from '../topbar/topbar.component';
import { BrandingDirective } from './branding.directive';

@Component({
  selector: 'spx-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  imports: [
    CommonModule,
    MatSidenavModule,
    MatDividerModule,
    FlexLayoutModule,
    RouterModule,
    MatToolbarModule,
    MatSidenavModule,
    TopbarComponent,
  ],
})
export class SidenavComponent {
  /**
   * Opened state of sidebar
   */
  public opened = true;

  /**
   * Mobile breakpoint stream
   */
  public isMobile: Observable<boolean>;

  @ContentChild(BrandingDirective, { static: true }) brandingTemplate?: BrandingDirective;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
  ) {
    this.isMobile = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

    // close the sidebar on mobile
    this.isMobile.subscribe((isMobile) => {
      this.opened = !isMobile;
    });

    // close the sidebar, when a navigation was triggered on mobile
    combineLatest([this.isMobile, this.router.events]).subscribe(([isMobile, navigationEvent]) => {
      if (isMobile === true && navigationEvent instanceof NavigationEnd) {
        this.opened = false;
      }
    });
  }

  /**
   * Toggles the sidebar
   */
  toggle() {
    this.opened = !this.opened;
  }
}
